import { api } from "../adminApis";
import { IAPIResponse } from "../../models/api";
import { IProgramFeatureResponse } from "../../models/program";

export const fetchNavigationItems = () => {
  return api.get<IAPIResponse<IProgramFeatureResponse[]>>(`/program/features`);
};
